export default "__VITE_ASSET__7ef1f392__"